import { Box, Grid, Skeleton } from "@mui/material";

const SkeletonBody = ({
  isPopupView,
  isOnboarding,
}: {
  isPopupView?: boolean;
  isOnboarding?: boolean;
}) => {
  if (isPopupView) {
    return (
      <Grid container gap={2} sx={{ p: 3 }}>
        <Grid container gap={2}>
          <Skeleton
            animation="wave"
            variant="rounded"
            height={50}
            width="20%"
          />
          <Skeleton
            animation="wave"
            variant="rounded"
            height={50}
            width="75%"
          />
        </Grid>

        <Skeleton animation="wave" variant="rounded" height={50} width="100%" />
        <Skeleton
          animation="wave"
          variant="rounded"
          height={200}
          width="100%"
        />

        <Skeleton animation="wave" variant="rounded" height={50} width="100%" />
        <Skeleton
          animation="wave"
          variant="rounded"
          height={200}
          width="100%"
        />
      </Grid>
    );
  }

  return (
    <Grid container rowSpacing={1} columnSpacing={2} sx={{ pb: 3 }}>
      <Grid item xs={12} sm={isOnboarding ? 12 : 6} md={isOnboarding ? 12 : 4}>
        <Skeleton animation="wave" variant="rounded" height={30} />
      </Grid>
      <Grid item xs={12} sm={isOnboarding ? 12 : 6} md={isOnboarding ? 12 : 4}>
        <Skeleton animation="wave" variant="rounded" height={30} />
      </Grid>
      <Grid item xs={12} sm={isOnboarding ? 12 : 6} md={isOnboarding ? 12 : 4}>
        <Skeleton animation="wave" variant="rounded" height={30} />
      </Grid>
      {isOnboarding && <Box sx={{ width: "100%", height: "16px" }} />}
      <Grid item xs={12} sm={isOnboarding ? 12 : 6} md={isOnboarding ? 12 : 4}>
        <Skeleton animation="wave" variant="rounded" height={30} />
      </Grid>
      <Grid item xs={12} sm={isOnboarding ? 12 : 6} md={isOnboarding ? 12 : 4}>
        <Skeleton animation="wave" variant="rounded" height={30} />
      </Grid>
      {!isOnboarding && (
        <>
          <Grid
            item
            xs={12}
            sm={isOnboarding ? 12 : 6}
            md={isOnboarding ? 12 : 4}
          >
            <Skeleton animation="wave" variant="rounded" height={30} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={isOnboarding ? 12 : 6}
            md={isOnboarding ? 12 : 4}
          >
            <Skeleton animation="wave" variant="rounded" height={30} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Skeleton animation="wave" variant="rounded" height={30} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Skeleton animation="wave" variant="rounded" height={30} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SkeletonBody;
